__turbopack_context__.v({
  "freeBox": "PlasmicReviewCard-module__K0O8JG__freeBox",
  "img": "PlasmicReviewCard-module__K0O8JG__img",
  "root": "PlasmicReviewCard-module__K0O8JG__root",
  "rootglobal_themeOrange_override": "PlasmicReviewCard-module__K0O8JG__rootglobal_themeOrange_override",
  "rootglobal_themePurpleDark_override": "PlasmicReviewCard-module__K0O8JG__rootglobal_themePurpleDark_override",
  "text___0MHkf": "PlasmicReviewCard-module__K0O8JG__text___0MHkf",
  "text__iw94H": "PlasmicReviewCard-module__K0O8JG__text__iw94H",
  "textglobal_themeOrange_override___0MHkfdYuRs": "PlasmicReviewCard-module__K0O8JG__textglobal_themeOrange_override___0MHkfdYuRs",
  "textglobal_themeOrange_override__iw94HdYuRs": "PlasmicReviewCard-module__K0O8JG__textglobal_themeOrange_override__iw94HdYuRs",
  "textglobal_themePurpleDark_override___0MHkfLKfzf": "PlasmicReviewCard-module__K0O8JG__textglobal_themePurpleDark_override___0MHkfLKfzf",
  "textglobal_themePurpleDark_override__iw94HlKfzf": "PlasmicReviewCard-module__K0O8JG__textglobal_themePurpleDark_override__iw94HlKfzf",
});
